export const MuiInputLabel = palette => ({
  styleOverrides: {
    root: {
      // textIndent: '-9999px'
    }
  }
})
